import Carousel from './components/Carousel.js';
import Header from './components/Header.js';
import YouTube from './components/YouTube.js';
import Plus from './components/Plus.js';
import Accordion from './components/Accordion.js';
import MenuDesignSystem from './components/MenuDesignSystem.js';
import Scrolly from './components/Scrolly.js';
import Calendrier from './components/Calendrier.js';
import Banner from './components/Banner.js';
import Modale from './components/Modale.js';

export default class ComponentFactory {
  constructor() {
    this.componentInstances = [];
    this.componentList = {
      Header,
      Carousel,
      YouTube,
      Plus,
      Accordion,
      MenuDesignSystem,
      Scrolly,
      Calendrier,
      Banner,
      Modale,
    };
    this.init();
  }
  init() {
    const components = document.querySelectorAll('[data-component]');

    for (let i = 0; i < components.length; i++) {
      const element = components[i];
      const componentName = element.dataset.component;

      if (this.componentList[componentName]) {
        const instance = new this.componentList[componentName](element);
        this.componentInstances.push(instance);
      } else {
        console.log(`La composante ${componentName} n'existe pas`);
      }
    }
  }
}
